export function checkServiceAndEmploymentUsesZorgmail(
    service: { isSuppressZorgmail: boolean },
    employment?: { zorgmailNummer: string | null },
    isManualZorgmail?: boolean
): boolean {
    if (isManualZorgmail) {
        return !!employment?.zorgmailNummer;
    }

    return !!employment?.zorgmailNummer && !service.isSuppressZorgmail;
}
